import React from 'react'
import yn from 'yn'

import editStayIcon from '../../../../assets/icons/edit-stay.svg'

const BkFlowStructuredSidebarPropertySummary = props => {
  const {
    activeHotel,
    hotelLabels,
    propertyAddress,
    propertyNumbers,
    toggleEditModal,
  } = props

  return (
    <div className="bk-flow-structured-sidebar__row property-summary">
      <h6
        id="bk-toggle-edit-stay"
        tabIndex={0}
        onClick={() => toggleEditModal()}
      >
        {activeHotel ? activeHotel : '--'}
        <img src={editStayIcon} alt="Edit Stay Details" />
      </h6>

      { yn(process.env.REACT_APP_COMPONENT_ENABLE_RESERVATIONS_PHONE) &&
        propertyNumbers &&
        propertyNumbers.reservations &&
        <div className="bk-flow-structured-sidebar__phone-reservations">
          <p>{hotelLabels & hotelLabels.reservationsPhone ? hotelLabels.reservationsPhone : 'Reservations'}&nbsp;</p>
          <a href={'tel:' + propertyNumbers.reservations}>{propertyNumbers.reservations}</a>
        </div>
      }

      { yn(process.env.REACT_APP_COMPONENT_ENABLE_PROPERTY_PHONE) &&
        propertyNumbers &&
        propertyNumbers.property &&
        <div className="bk-flow-structured-sidebar__phone-hotel">
          <p>{hotelLabels & hotelLabels.propertyPhone ? hotelLabels.propertyPhone : 'Property'}&nbsp;</p>
          <a href={'tel:' + propertyNumbers.property}>{propertyNumbers.property}</a>
        </div>
      }

      <div className="bk-flow-structured-sidebar__address">
        { propertyAddress &&
          propertyAddress.addressLine &&
          propertyAddress.addressLine[0] &&
          <p>{propertyAddress.addressLine[0]}</p>
        }

        { propertyAddress &&
         (propertyAddress.postalCode || propertyAddress.cityName || propertyAddress.countryName) &&
          <p>
            {propertyAddress.cityName && propertyAddress.cityName + ', '}
            {propertyAddress.countryName && propertyAddress.countryName + ' '}
            {propertyAddress.postalCode && propertyAddress.postalCode}
          </p>
        }
      </div>
    </div>
  )
}

export default BkFlowStructuredSidebarPropertySummary



// WEBPACK FOOTER //
// ./src/components/structure/sidebar/elements/BkFlowStructuredSidebarPropertySummary.js